import { Alert, Button, Spin } from "antd";
import useStaffAccountPreparation from "../hooks/useStaffAccountPreparation";

export default function StaffAccountGate({ children }) {
  const { accountStatus, accountError, retry, signOut } =
    useStaffAccountPreparation();

  if (accountStatus === "ready") return children;
  return (
    <main className="mx-auto flex min-h-screen w-full max-w-[640px] flex-col items-center justify-center gap-6 px-6 py-12">
      {accountStatus === "error" ? (
        <div className="flex w-full max-w-[400px] flex-col gap-5">
          <Alert
            type="error"
            showIcon
            message="Account setup failed"
            description={accountError}
          />
          <Button type="primary" block onClick={retry}>
            Retry account setup
          </Button>
        </div>
      ) : (
        <div
          role="status"
          aria-live="polite"
          aria-busy="true"
          className="flex flex-col items-center gap-3 text-center"
        >
          <Spin />
          <p className="m-0 text-sm text-text-default-secondary">
            Preparing your account…
          </p>
        </div>
      )}
      <Button type="link" onClick={signOut}>
        Sign out
      </Button>
    </main>
  );
}
